import { useGraphqlQuery } from "graphql-mock"
import { Card } from "materia"
import { useTranslation } from "react-i18next"
import { sanitizeHtml } from "ui-tools"
import {
  FiestaImage,
  FiestaLink,
  type FiestaLinkProps,
} from "utility-components"
import { WidgetLink } from "../../../components/Widget"
import { query } from "./gql"
import { NewsWidgetMobileError } from "./NewsWidgetMobileError"
import { NewsWidgetMobileSkeleton } from "./NewsWidgetMobileSkeleton"

import s from "./NewsWidgetMobile.module.scss"

export const NewsWidgetMobile = () => {
  const { t } = useTranslation()
  const { data, error, isPending } = useGraphqlQuery(query, {})

  if (isPending) return <NewsWidgetMobileSkeleton />
  if (error) return <NewsWidgetMobileError error={error} />

  const isEnabled =
    data.currentCompany.portalFeatureFlags.includes("enable_portal_news")

  const newsPost = data.newsPosts.nodes[0]

  if (!newsPost) return
  if (!isEnabled) return

  return (
    <Card>
      <div className={s.widget}>
        <Item
          link={{ to: `/news/post/${newsPost.id}` }}
          key={newsPost.id}
          title={t("news.NEWS")}
          description={newsPost.headline ?? ""}
          image={newsPost.image ?? ""}
        />
      </div>
    </Card>
  )
}

const Item = ({
  link,
  title,
  description,
  image,
}: {
  link: FiestaLinkProps
  title: string
  description: string
  image: string
}) => {
  return (
    <FiestaLink {...link} className={s.item}>
      <FiestaImage className={s.item__image} src={image} alt="" sizes="60px" />
      <div className={s.item__wrapper}>
        <div className={s.item__title}>{title}</div>
        <h3
          className={s.item__description}
          dangerouslySetInnerHTML={sanitizeHtml(description, "strict")}
        />
      </div>

      <WidgetLink to="/news" ariaLabel="Open news page" />
    </FiestaLink>
  )
}
